module.exports = {
          srcSet: __webpack_public_path__ + "public/images/de330d61fb2aebe9a316aadc8cad423d-1905.webp"+" 1905w",
          images:[ {path: __webpack_public_path__ + "public/images/de330d61fb2aebe9a316aadc8cad423d-1905.webp",width: 1905,height: 682}],
          src: __webpack_public_path__ + "public/images/de330d61fb2aebe9a316aadc8cad423d-1905.webp",
          toString:function(){return __webpack_public_path__ + "public/images/de330d61fb2aebe9a316aadc8cad423d-1905.webp"},
          
          width: 1905,
          height: 682
        }